import { Component } from '@angular/core';
import {
  Event,
  Router,
  NavigationStart,
  NavigationEnd,
} from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { PlatformLocation } from '@angular/common';
import { Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  currentUrl: string;

  constructor(
    public _router: Router,
    location: PlatformLocation,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
    // Prevenir traducción del navegador
    this.preventBrowserTranslation();

    this._router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        this.spinner.show();
        // location.onPopState(() => {
        //   window.location.reload();
        // });
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf('/') + 1
        );
      }
      if (routerEvent instanceof NavigationEnd) {
        this.spinner.hide();
      }
      window.scrollTo(0, 0);
    });
  }

  private preventBrowserTranslation(): void {
    // Agregar atributo translate="no" al body
    this.renderer.setAttribute(this.document.body, 'translate', 'no');

    // Agregar clase notranslate al body (para Google Translate)
    this.renderer.addClass(this.document.body, 'notranslate');

    // Forzar el idioma español
    this.renderer.setAttribute(this.document.documentElement, 'lang', 'es');
  }
}
